export interface LocationConfig {
  name: string;
}

export const LOCATIONS: LocationConfig[] = [
  { name: 'Berlin' },
  { name: 'Frankfurt' },
  { name: 'Liebfrauen' },
  { name: 'Kopernikus' },
  { name: 'Neumuehle' },
  { name: 'Paedagogium' }
];
